var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 35.87 238.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.3;}.cls-2{fill:url(#linear-gradient);}.cls-3{opacity:0.05;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 18.3,
    y1: 1.03,
    x2: 18.3,
    y2: 238.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a535f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06304b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 25.9,
    y1: -0.37,
    x2: 25.9,
    y2: 237.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 9.97,
    y1: -0.37,
    x2: 9.97,
    y2: 237.05,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timeline"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.3,1c.21,9.88.31,19.75.46,29.63L19,60.28c.16,19.75.14,39.5.22,59.25-.07,19.75-.07,39.5-.22,59.25l-.26,29.63c-.16,9.88-.25,19.75-.46,29.63-.21-9.88-.31-19.75-.46-29.63l-.26-29.63c-.15-19.75-.14-39.5-.22-59.25.08-19.75.06-39.5.22-59.25l.26-29.63C18,20.78,18.09,10.9,18.3,1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.93,0c2,4.62,3.6,9.36,5.11,14.14s2.88,9.61,4.14,14.47q3.69,14.59,6.06,29.48C32.86,68,33.93,78,34.7,88s1.19,20.05,1.16,30.09-.39,20.08-1.21,30.09l-.27,3.76L34,155.69l-.73,7.49c-.63,5-1.17,10-2,14.92l-1.17,7.43c-.39,2.48-.9,4.94-1.34,7.41s-.88,4.94-1.41,7.39l-1.58,7.36L25,211.37,24.08,215l-1.82,7.3c-1.25,4.85-2.69,9.66-4,14.48l1.79-7.3c.58-2.44,1.26-4.85,1.77-7.3l1.61-7.34.81-3.67.7-3.69,1.44-7.37c.49-2.45.85-4.93,1.28-7.39s.86-4.93,1.21-7.41l1-7.43c.37-2.47.65-5,.92-7.44l.87-7.45.69-7.47.34-3.73.25-3.74c.76-10,1-20,1-30A408.18,408.18,0,0,0,29.8,58.31q-2.13-14.85-5.53-29.48A235.93,235.93,0,0,0,15.93,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19.94,0a235.93,235.93,0,0,0-8.35,28.83Q8.19,43.44,6.07,58.31A408.18,408.18,0,0,0,1.89,118.1c0,10,.27,20,1,30l.25,3.74.34,3.73L4.2,163l.87,7.45c.27,2.49.55,5,.92,7.44l1,7.43c.34,2.48.81,4.94,1.21,7.41s.79,4.94,1.28,7.39L11,207.5l.7,3.69.81,3.67,1.61,7.34c.51,2.45,1.19,4.86,1.77,7.3l1.79,7.3c-1.36-4.82-2.8-9.63-4-14.48L11.78,215l-.91-3.65-.81-3.67-1.58-7.36c-.53-2.45-.94-4.93-1.41-7.39s-1-4.93-1.34-7.41l-1.17-7.43c-.82-5-1.35-9.95-2-14.92l-.73-7.49-.36-3.75-.27-3.76C.39,138.18.09,128.14,0,118.1S.43,98,1.16,88,3,68,4.63,58.09s3.6-19.76,6.06-29.48c1.26-4.86,2.61-9.69,4.14-14.47S18,4.62,19.94,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg2.3681730564cee3ceb7c61623d7517992.svg";
export { ForwardRef as ReactComponent };